webpackJsonp([64849619966374],{

/***/ 447:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var D1 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/1.png";
	var D2 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/2.png";
	var D3 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/3.png";
	var D4 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/4.png";
	var D5 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/5.png";
	var D6 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/6.png";
	var D7 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/7.png";
	var D8 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/8.png";
	var D9 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/9.png";
	var D10 = "https://bawamasalacompany.com/assets/images/InfographicsIcon/10.png";
	
	var col1 = exports.col1 = [{
		text: "Legacy of over seven decades of excellence in production of premium spices and spice blends",
		imgSrc: D1
	}, {
		text: "Traditional recipe blends, made even better through constant innovation.",
		imgSrc: D2
	}, {
		text: "State-of-art technology with the finest machinery.",
		imgSrc: D3
	}, {
		text: "Best manufacturing processes and standard in the industry.",
		imgSrc: D4
	}, {
		text: "Premium quality, with an international reputation.",
		imgSrc: D5
	}, {
		text: "Fumigation to keep the quality of the product intact and increase shelf life.",
		imgSrc: D6
	}, {
		text: "Unparallelled cleaning and processing capacity ",
		imgSrc: D7
	}, {
		text: "Best in class marketing support and highly trained sales staff",
		imgSrc: D8
	}, {
		text: "Attractive trade schemes for dealers and stockists",
		imgSrc: D9
	}, {
		text: "High customer satisfaction, confidence and continuous quality improvement ",
		imgSrc: D10
	}];

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.LegacyView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(632);
	
	var _Heading = __webpack_require__(43);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _legacyConstant = __webpack_require__(447);
	
	var _contentPage = __webpack_require__(19);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(20);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DarjiLogo = "https://bawamasalacompany.com/assets/images/Elements/S_Bawa_Sardar_Singh_Bhalla.png";
	
	var duration = 400;
	
	var LegacyView = exports.LegacyView = function (_React$Component) {
	  _inherits(LegacyView, _React$Component);
	
	  function LegacyView(args) {
	    _classCallCheck(this, LegacyView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {
	      showTrans: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    return _this;
	  }
	
	  LegacyView.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _reactFacebookPixel2.default.init("145006083100066");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    setTimeout(function () {
	      _this2.setState({
	        showTrans: true,
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  LegacyView.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.setState({
	      showTrans: true,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0.1
	      }
	    });
	  };
	
	  LegacyView.prototype.render = function render() {
	    var defaultStyle = this.state.defaultStyle;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "BMC Estd. 1952 | 7 Decades of Leadership in Spice Products",
	        description: "Bawa Masala Company, established 1952, is a leading manufacturer of quality spice products delivered globally. Enquire about dealership and bulk orders.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "global__wrapper", style: { background: "#e9eef6" } },
	        _react2.default.createElement(
	          "div",
	          { className: "legacy__wrapper", style: defaultStyle },
	          _react2.default.createElement(_Heading2.default, { title: "Legacy" }),
	          _react2.default.createElement(
	            "div",
	            { className: "panel__1" },
	            _react2.default.createElement(
	              "div",
	              { className: "row __media" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 __media__left" },
	                _react2.default.createElement("img", { src: DarjiLogo, alt: "S_Bawa_Sardar Singh_Bhalla", className: "img img-responsive" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "name" },
	                  "S.Bawa Sardar Singh Bhalla"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "founder" },
	                  "Founder of Bawa Masala Company"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-9 __media__body" },
	                "After starting in 1952, on a humble note, with a small unit having a capacity to produce merely four basic spices, BMC, thanks to the firm commitment to deliver quality, is today a giant Masala Company.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "After nearly seven decades of expertise in spice and spice blends, BMC is today renowned in the domestic and international market for being at the forefront with an emphasis on premium quality, constant innovation and consistent delivery on timeless recipes and taste.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "For good reason. Before hitting the shelf at the outlets, each hygienically produced BMC product undergoes stringent quality tests and is packed to keep the freshness and wholesomeness intact for the consumer. Our hi-tech production plant and diligent supervision at each stage during the production process ensure the quality that is a hallmark of BMC.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "BMC products offer a vast range of variety, tickling the taste buds of every food lover."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "panel__2" },
	            _react2.default.createElement(_Heading2.default, { title: "Infrastructure, expertise and process", size: "large" }),
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(
	                "div",
	                { className: "sub__heading" },
	                "Bawa Masala Company has international standard infrastructure, well-poised to meet the daily rigours of global demand for premium Indian spices"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _legacyConstant.col1.map(function (item, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-sm-6", key: i },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "info" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "info-img" },
	                        _react2.default.createElement("img", { src: item.imgSrc, alt: item.text, className: "" })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "info-text" },
	                        item.text
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LegacyView;
	}(_react2.default.Component);
	
	exports.default = LegacyView;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legacy-index-js-6af38594bfcde5781ac8.js